import { render, staticRenderFns } from "./SignerBox.vue?vue&type=template&id=ec91e436&"
import script from "./SignerBox.vue?vue&type=script&lang=ts&"
export * from "./SignerBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports